// TSS vite/04 §"Endpoint paths". baseURL already includes /api/v1.

export const animalPaths = {
    list:        ()          => 'admin/animals',
    detail:      (id)        => `admin/animals/${id}`,
    byNumber:    (number)    => `admin/animals/by-number/${number}`,
    byRegister:  (reg)       => `admin/animals/by-register/${reg}`,
    owners:      (id)        => `admin/animals/${id}/owners`,
    owner:       (id, oid)   => `admin/animals/${id}/owners/${oid}`,
    // Avalúo (valor de inventario) del animal — decisión 0098 · Q-286.
    valuations:  (id)        => `admin/animals/${id}/valuations`,
    valuation:   (id, vid)   => `admin/animals/${id}/valuations/${vid}`,
    // Ubicación / traslado de finca (0036) — simple: setea current_farm_id + bitácora animal_farm_moves.
    transferFarm: (id)       => `admin/animals/${id}/transfer-farm`,
    farmMoves:    (id)       => `admin/animals/${id}/farm-moves`,
    // Desglose reproductivo OPU de la donadora (0109).
    opuBreakdown: (id)       => `admin/animals/${id}/opu-breakdown`,
};
